/**
 * The one surface treatment every HUD panel wears.
 *
 * A low-alpha fill over a *light* blur rather than solid chrome, and lighter than the panels
 * started out: the arena is the thing worth looking at, and a player has to be able to see the
 * dot they are about to eat through whichever corner it happens to be behind. The blur radius is
 * the half of that which matters — a heavier one smears a pellet into the fill, so the panel
 * stops being see-through in the only sense a player cares about.
 *
 * Shared rather than repeated because the three panels sit in the same two corners: one of them
 * being a shade more solid than its neighbours reads as a bug, not as emphasis.
 */
/**
 * `hud-panel` is a marker rather than a style: it carries no rules of its own in the default
 * profile, and it is what the cheap compositor profile in `app.css` takes hold of to put the
 * fill's alpha back up when it drops the blur. A marker class rather than a second constant,
 * because every panel that wears this string must move together — one of them staying blurred on
 * a phone would be the single most expensive thing on the screen.
 */
export const HUD_PANEL_CLASS =
  'hud-panel rounded-lg border border-border/40 bg-card/20 shadow-lg backdrop-blur-sm';
